export const initialState = {
  rows: [],
  loading: false,
  error: null,
};
